import lenoxData from "./lenoxData.js"

// vignette table fields
var productDisplayNameInd = 0;
var vignetteUrlFragmentInd = 1;
var productNumFeaturesInd = 2;
var productSkuIndex = 1;


function searchTable(value, table, index) {
    for (var i = 0; i < table.length; i++) {
        if (table[i][index] == value) {
            return true;
        }
    }
    return false;
}


function searchTableForField(value, table, idIndex, fieldIndex) {
    for (var i = 0; i < table.length; i++) {
        if (table[i][idIndex] == value) {
            return table[i][fieldIndex];
        }
    }
    return null;
}


function populateAllProducts(selector, vignetteTable) {
    for (var i = 0; i < vignetteTable.length; i++) {
        selector.options[i] = new Option(vignetteTable[i][0]);
    }
}


function sortit(a, b) {
    return a.replace(/\D.*/, "") - b.replace(/\D.*/, "");
}


function populateProductsSortedByNumber(selector, productTable, vignetteTable) {
    var options = new Array(productTable.length);

    for (var i = 0; i < productTable.length; i++)
        options[i] = productTable[i][0];

    options.sort(sortit);

    var optionIndex = 0;
    for (var j = 0; j < options.length; j++) {
        //if (searchTable(options[j], vignetteTable, 0))  this should work
        selector.options[optionIndex++] = new Option(options[j]);
    }
}


function populateProducts(selector, productTable, vignetteTable) {
    var optionIndex = 0;
    for (var i = 0; i < productTable.length; i++) {
        if (searchTable(productTable[i][1], vignetteTable, 0))
            selector.options[optionIndex++] = new Option(productTable[i][0]);
    }
}


function lookupSku(productID, productTable) {
    for (var i = 0; i < productTable.length; i++) {
        if (productID == productTable[i][productSkuIndex]) {
            return productTable[i][productSkuIndex];
        }
    }
    return "undefined";
}


function getSelectedProductId(productSelector, productTable) {
    var pid = productSelector.options[productSelector.selectedIndex].text;
    return (pid == "") ? productTable[0][productDisplayNameInd] : pid;
}


function getSelectedProductSku(productSelector, productTable) {
    var pid = productSelector.options[productSelector.selectedIndex].text;
    if (pid == "")
        return productTable[0][productSkuIndex];
    else
        return lookupSku(pid, productTable);
}


function getAllFeatureValues(productSelector, productTable, vignetteTable, baseId) {
    var selectedProduct = getSelectedProductSku(productSelector, productTable);
    var numFeatures = getNumFeatures(selectedProduct, vignetteTable, productTable);
    var allFeatures = new Array(numFeatures);

    for (var i = 0; i < numFeatures; i++)
        allFeatures[i] = document.getElementById(baseId + (i + 1)).value;

    return allFeatures;
}


function getVignetteUrlFragment(selectedProduct, vignetteTable, productTable) {
    var selectedProductSku = lookupSku(selectedProduct, productTable);

    for (var i = 0; i < vignetteTable.length; i++) {
        if (selectedProductSku == vignetteTable[i][productDisplayNameInd]) {
            return vignetteTable[i][vignetteUrlFragmentInd];
        }
    }
}


function getVignetteUrlFragmentSubstituted(selectedProduct, vignetteTable, baseId) {

    var frag = getVignetteUrlFragment(selectedProduct, vignetteTable)
    var numSubstitutions = getNumFeatures(selectedProduct, vignetteTable);

    var currText;
    for (var i = 0; i < numSubstitutions; i++) {
        currText = document.getElementById(baseId + (i + 1)).value;
        var regExp = /\$\d\$/;
        frag = frag.replace(regExp, currText);
    }
    return frag;
}


function getNumFeatures(selectedProduct, vignetteTable, productTable) {
    var selectedProductSku = lookupSku(selectedProduct, productTable);
    if (selectedProductSku == "undefined")
        selectedProductSku = selectedProduct;
    for (var i = 0; i < vignetteTable.length; i++) {
        if (selectedProductSku == vignetteTable[i][productDisplayNameInd]) {
            return vignetteTable[i][productNumFeaturesInd];
        }
    }
    return "getNumFeatures can't find " + selectedProductSku + " in vignette table";
}


function enableControls2(numControls, numFeatures, controlIdPrefix, isTextControl) {
    var currControl;
    for (var i = 0; i < numControls; i++) {
        currControl = document.getElementById(controlIdPrefix + (i + 1));
        if (i < numFeatures) {
            currControl.disabled = false;
            if (isTextControl && currControl.value.indexOf("N/A") != -1)
                currControl.value = "";
            else
                currControl.selectedIndex = 0;
        } else {
            currControl.disabled = true;
            if (isTextControl)
                currControl.value = "N/A";
            else
                currControl.selectedIndex = 0;
        }
    }
}


function enableControls(numControls, controlIdPrefix, vignetteTable, productTable, isTextControl) {
    var selectedProduct = getSelectedProductSku(document.jewelryForm.product, productTable);
    var numFeatures = getNumFeatures(selectedProduct, vignetteTable, productTable);
    enableControls2(numControls, numFeatures, controlIdPrefix, isTextControl);
}


function getStonesArray(selectedProduct, vignetteTable, productTable, baseId) {
    var selectedProductSku = lookupSku(selectedProduct, productTable);
    var numStones = getNumFeatures(selectedProductSku, vignetteTable, productTable);

    var stoneName;
    var stones = new Array(numStones);
    for (var i = 0; i < numStones; i++) {
        var selector = document.getElementById(baseId + (i + 1));
        var selectedIndex = selector.selectedIndex;
        if (selectedIndex == -1)
            selectedIndex = 0;
        stoneName = selector.options[selectedIndex].text;
        stones[i] = stoneName;
    }
    return stones;
}

// color lookup table fields
var itemDisplayNameInd = 0;
var rgbColorInd = 1;

function populateGemSelectors(pSelector, pTable, baseId, numSelectors) {
    var selectedProductId = getSelectedProductId(pSelector, pTable);
    var gemTable = getGemTable(selectedProductId);

    //document.writeln("gemTable.length: " + gemTable.length);

    var selector;
    for (var i = 0; i < numSelectors; i++) {
        selector = document.getElementById(baseId + (i + 1));

        var j;
        for (j = 0; j < gemTable.length; j++) {
            selector.options[j] = new Option(gemTable[j][itemDisplayNameInd]);
        }
        //if (i > 0)
        selector.options[j] = new Option(NO_STONE_LABEL);
    }
}

function populateGemSelectors2(pSelector, pTable, baseId, numSelectors) {
    var selectedProductId = getSelectedProductId(pSelector, pTable);
    var gemTable = getGemTable(selectedProductId);

    //document.writeln("gemTable.length: " + gemTable.length);

    var selector;
    for (var i = 0; i < numSelectors; i++) {
        selector = document.getElementById(baseId + (i + 1));
        for (var j = 0; j < gemTable.length; j++) {
            selector.options[j] = new Option(gemTable[j][itemDisplayNameInd]);
        }
    }
}

function populateSnowFlakeSelectors(baseId, numSelectors) {
    var selector;
    for (var i = 0; i < numSelectors; i++) {
        selector = document.getElementById(baseId + (i + 1));

        var j;
        for (j = 0; j < lenoxData.snowFlake.length; j++) {
            selector.options[j] = new Option(lenoxData.snowFlake[j][itemDisplayNameInd]);
        }
        //if (i > 0)
        selector.options[j] = new Option(NO_ORNAMENT_LABEL);
    }
}


function getItemRGBColor(itemName, colorLookupTable) {
    for (var i = 0; i < colorLookupTable.length; i++) {
        if (itemName == colorLookupTable[i][itemDisplayNameInd]) {
            return colorLookupTable[i][rgbColorInd];
        }
    }
    return "undefined";
}

function getGemTable(productID) {
    for (var i = 0; i < lenoxData.gemMasterTable.length; i++) {
        if (lenoxData.gemMasterTable[i][0] == productID)
            return lenoxData.gemMasterTable[i][1];
    }

    return null;
}

var NO_STONE_LABEL = ">>>>> NO STONE <<<<<";
var NO_ORNAMENT_LABEL = ">>>>> NO ORNAMENT <<<<<";

export default {
    productDisplayNameInd: productDisplayNameInd,
    vignetteUrlFragmentInd: vignetteUrlFragmentInd,
    productNumFeaturesInd: productNumFeaturesInd,
    productSkuIndex: productSkuIndex,
    searchTable: searchTable,
    searchTableForField: searchTableForField,
    populateAllProducts: populateAllProducts,
    sortit: sortit,
    populateProductsSortedByNumber: populateProductsSortedByNumber,
    populateProducts: populateProducts,
    lookupSku: lookupSku,
    getSelectedProductId: getSelectedProductId,
    getSelectedProductSku: getSelectedProductSku,
    getAllFeatureValues: getAllFeatureValues,
    getVignetteUrlFragment: getVignetteUrlFragment,
    getVignetteUrlFragmentSubstituted: getVignetteUrlFragmentSubstituted,
    getNumFeatures: getNumFeatures,
    enableControls2: enableControls2,
    enableControls: enableControls,
    getStonesArray: getStonesArray,
    itemDisplayNameInd: itemDisplayNameInd,
    rgbColorInd: rgbColorInd,
    populateGemSelectors: populateGemSelectors,
    populateGemSelectors2: populateGemSelectors2,
    populateSnowFlakeSelectors: populateSnowFlakeSelectors,
    getItemRGBColor: getItemRGBColor,
    getGemTable: getGemTable,
    NO_STONE_LABEL: NO_STONE_LABEL,
    NO_ORNAMENT_LABEL: NO_ORNAMENT_LABEL
};



// WEBPACK FOOTER //
// ../assets/js/personalize/preview/commonFunctions.js